import React from "react";
import { MasterConfigs } from "../../../../../interfaces/entity";
import MasterComponent from "../../../../../components/Forms";

const ColumnSettings = ({ projectId }) => {

    const config: MasterConfigs = {
        api: () => `/columns/${projectId}`,
        modalTitle: (action) => `${action} Column`,
        isActionTab: true,
        getColumns: () => [
            {
                title: 'Name',
                dataIndex: 'name',
                key: 'name'
            },
            {
                title: 'Category',
                dataIndex: 'category',
                key: 'category'
            },
            {
                title: 'Color',
                dataIndex: 'color',
                key: 'color',
                render: (text) => <div style={{ backgroundColor: text, width: 50, height: 20 }}></div>
            },
            {
                title: 'Order',
                dataIndex: 'order',
                key: 'order'
            }
        ],
        getFormColumns: () => [
            {
                type: 'text',
                name: 'name',
                label: 'Name'
            },
            {
                name: 'category',
                label: 'Category',
                type: 'select',
                children: ['To_Do', 'In_Progress', 'Done', 'other'].map(ele => ({ name: ele, value: ele })),
            },
            {
                type: 'color',
                name: 'color',
                label: 'Color',
                colorProps: {
                    width: 200
                }
            }
        ],
        actions: [
            {
                name: 'Add Column',
                actionType: 'Add',
                settings: {
                    type: 'primary'
                }
            }
        ]
    }

    return <MasterComponent config={config} />
}

export default ColumnSettings;